<template>
  <WdsStack gap-xs align-center justify-space-between class="tw-max-w-[200px] employment-hiring-manager-column">
    <WdsText :text="mainOwner" />
    <WdsTooltip v-if="owners.length > 1" :global="tableGlobals">
      <template #tooltip-content>
        <span v-for="(owner, index) in owners" :key="owner.id">
          {{ `${owner.name}${index < owners.length - 1 ? ',' : ''}` }}
          <br />
        </span>
      </template>
      <WdsLabel sm class="tw-whitespace-nowrap">+ {{ owners.length - 1 }}</WdsLabel>
    </WdsTooltip>
  </WdsStack>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsLabel, WdsStack, WdsText, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { extractHiringManagers, extractMainHiringManager } from '@/components/Employments/Partner/EmploymentExportConfig'
import { useTableGlobalsSelector } from '@/components/GraphqlDataTable/injection'

const tableGlobals = useTableGlobalsSelector()

const EmploymentHiringManagerColumn = graphql(`
  fragment EmploymentHiringManagerColumn on Employment {
    id
    hiringManagers {
      id
      name
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentHiringManagerColumn> }>()
const column = computed(() => useFragment(EmploymentHiringManagerColumn, props.row))

const owners = computed(() => extractHiringManagers(column.value))
const mainOwner = computed(() => extractMainHiringManager(column.value))
</script>

<style lang="scss">
.employment-hiring-manager-column {
  .wds-text {
    @apply tw-truncate;
    .wds-text-primary {
      @apply tw-truncate;
    }
  }
}
</style>
